<template>
  <!-- <div style="background-color:rgb(189, 0, 0);" class="main d-flex justify-content-start">
            <div style="background-color:rgb(255, 254, 254); width:66.2%;margin-top: 4px;display: flex;justify-content: center;height:555px"> -->
  <div class="main d-flex justify-content-start flex-wrap position-relative">
    <div class="innerMain">
      <span class="cancel-receipt" v-if="cancel">
          CANCEL
      </span>
      <div class="receipt">
        <div class="headerClass">
          <div style="margin-left: 20px">
            <p class="MsoBodyText" style="margin: 0px; display: flex; justify-content: center">
              <span style="font-size: 10pt"><img width="120" height="90"
                  src="../../../nestoria receipt FINAL (3)_files/logo.jpg" />
              </span>
            </p>
          </div>
          <div style="
          font-size: 10px;
          display: flex;
          margin-right: 20px;
          justify-content: end;
          align-items: center;
          ">
          <div style="
          font-weight: bold;
          color:black;
          ">
              <div class="d-flex w-100 justify-content-end companyName">
                Nestoria Buildcon Pvt. Ltd.
              </div>
              <div class="w-100 d-flex justify-content-end">
                Head Office : B 204-205, West Gate, Near YMCA Club, S.G. Highway,
                Ahmedabad - 380015
              </div>
              <div class="w-100 d-flex justify-content-end">
                Contact us : 7486003358
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative;display: flex;flex-direction:column;align-items:center; width:100% justify-content: center; margin-top: -30px" >
          <div class="payment" >Payment Receipt</div>
          <div class="borderImg">
              <img width="100%" :height="3"  id="image6.png" src="../../../nestoria receipt FINAL (3)_files/image006.png" />
          </div>
        </div>

        <div class="receiptTable">
          <table class="mainTable" style="font-weight: bolder; font-size: 10px" width="100%">
            <tr class="tr">
              <td class="td">Receipt No.</td>
              <td class="td" style="font-weight: bolder; color: black" colspan="6">
                {{ receiptData ? receiptData.receiptNo : "" }}
              </td>
              <td class="td">Date</td>
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData?moment(receiptData.approved1datetime ? receiptData.approved1datetime:new Date()).format("DD/MM/yyyy"):'' }}
              </td>
            </tr>
            <tr class="tr">
              <td class="td">Mr. /Mrs./Ms.</td>
              <td class="td" style="font-weight: bolder; color: black" colspan="8">
                {{ receiptData ? receiptData.clientname.name : "" }}&nbsp;{{
                  receiptData ? receiptData.clientname.surname : ""
                }}
                <span v-for="(item,index) in (receiptData ? receiptData.extra_customer_data:[])" :key="index">
                   {{ index+1  ==  receiptData.extra_customer_data .length?' and ':', ' }} {{ item.name  }}&nbsp;{{
                     item.surname
                   }}
                </span>
              </td>
            </tr>
            <tr class="tr">
              <td class="td">Received Amt.</td>
              <td class="td" style="font-weight: bolder; color: black" colspan="8">
                {{ receiptData ? receiptData.amountinwords : "" }}
              </td>
            </tr>
            <tr class="tr">
              <td class="td">Project Name</td>
              <td class="td" colspan="8" style="font-weight: bolder; color: black">
                {{ receiptData && receiptData.project ? receiptData.project.projectname : "" }}
              </td>
            </tr>


            <tr class="tr" v-if="receiptData && receiptData.receipt_items.length == 1">
              <td class="td" :rowspan="receiptData ? receiptData.receipt_items.length + 1 : 1" style="align-item:center">Suggested Plot & Payment Details</td>
              <td class="td" colspan="4">Suggested Plot No</td>
              <td class="td" colspan="6">Amount (Rs.)</td>
            </tr>
            <tr class="tr" v-if="receiptData && receiptData.receipt_items.length == 1" v-for="(item, index) in (receiptData?receiptData.receipt_items:[])" :key="index">
              <td class="td" colspan="4" style="font-weight: bolder; color: black">
                {{ item.plot_data && item.plot_data.length > 0 ? item.plot_data[0].plotno : '' }}
              </td>
              <td class="td" style="font-weight: bolder; color: black" colspan="6">
                {{ item.amount?parseFloat(item.amount).toLocaleString('en-In') :0}}
              </td>
            </tr>

             <tr class="tr" v-if="receiptData && receiptData.receipt_items.length > 1">
                  <td class="td" style="align-item:center">Suggested Plot & Payment Details</td>
                  <td class="td" colspan="8" style="font-weight: bolder; color: black">
                    <div class="d-flex flex-wrap" v-if="receiptData.paymenttype == 'Token'">
                      <div style="margin-right:10px" v-for="(item, index) in receiptData.receipt_items" :key="index">
                          {{ item.plot_data[0].plotno }} <span v-if="receiptData.receipt_items.length !== index + 1">, </span>
                        </div>

                    </div>
                    <div v-else class="d-flex flex-wrap" >
                      <div style="margin-right:10px" v-for="(item, index) in receiptData.receipt_items" :key="index">
                        {{ item.plot_data[0].plotno }} ( {{ item.amount}} ₹ ) <span v-if="receiptData.receipt_items.length!==index+1">, </span>
                      </div>
                    </div>
                  </td>
              </tr>

            <tr class="tr">
              <td class="td">Booking Date</td>
              <td class="td" style="font-weight: bolder; color: black" colspan="6">
                {{ receiptData ? receiptData.receipt_items[0].sales_data[0].bookingdate.split('-').reverse().join('/') : "" }}
              </td>
              <td class="td">Payment Type</td>
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData ? receiptData.paymenttype : "" }}
              </td>
            </tr>
            <tr class="tr">
              <td class="td">Address</td>
              <td class="td" style="font-weight: bolder; color: black" colspan="8">
                {{ receiptData ? receiptData.clientname.curarea : "" }},
                {{ receiptData ? receiptData.clientname.curcity : "" }},
                {{ receiptData ? receiptData.clientname.curarea : "" }},
                {{ receiptData ? receiptData.clientname.curpincode : "" }},
                {{ receiptData ? receiptData.clientname.curstate : "" }}
              </td>
            </tr>

            <tr class="tr">
              <td class="td">Payment By</td>
              <td class="td" colspan="4">Payment Date</td>
              <td class="td">Bank</td>
              <td class="td">Transaction No.</td>
              <td class="td">Branch</td>
              <td class="td">Amount</td>
            </tr>
            <tr class="tr">
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData ? receiptData.transactiontype : "" }} - ({{ receiptData ? receiptData.ledgername.name : "" }})
              </td>
              <td class="td" style="font-weight: bolder; color: black" colspan="4">
                {{ receiptData ? receiptData.transaction_date : "" }}
              </td>
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData ? receiptData.bankname : "" }}
              </td>
              <td class="td" style="font-weight: bolder; color: black">
                {{
                  receiptData
                  ?receiptData.transactiontype == "By Cheque"
                    ? receiptData.chequeno
                    : (receiptData.utrno
                      ? receiptData.utrno
                      : receiptData.refno)
                  : ""
                }}
              </td>
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData ? receiptData.branchname : "" }}
              </td>
              <td class="td" style="font-weight: bolder; color: black">
                {{ receiptData?parseFloat(receiptData.amount).toLocaleString('en-In') :0 }} /-
              </td>
            </tr>
          </table>
        </div>

        <div class="foo">
          <img width="100%" :height="3"  id="image6.png" src="../../../nestoria receipt FINAL (3)_files/image006.png" />
          <div class="RulesDiv">
            <p class="rule">
              1. The Receipt dose not create any right title interest in the Property/Plot.
            </p>
            <p class="rule">
              2. Any Payment once received shall non refundable in any circumstances after 15 days from booking.
            </p>
            <p class="rule">
              3. In case of any dispute all rights reserved by management.
            </p>
            <p class="rule">4. The receipt of Payment for suggested Plot only.</p>
            <p class="rule">5. Final Plot no will be allotted after full payment received.</p>
            <p class="rule">
              6. After registry of plot this receipt will be null or void.
            </p>
            <p class="rule">7. Subject to Ahmedabad Jurisdiction.</p>

          </div>
          <div class="mt-1" style="margin-right: 10px; font-size: 11px; font-weight: bolder">
            <img width="100" height="100" src="../../../nestoria receipt FINAL (3)_files/AutoritySign.jpeg" />
          </div>
          <div class="mainfoo">
            <div class="childfoo">
              <span style="margin-left: 20px">sale@nestoriagroup.com</span>
              <span style="font-size: 50px">/</span>
              <span style="margin-right: 20px">www.nestoriagroup.com</span>
            </div>
          </div>
        </div>
        <!-- <img width=100% height=40 src="../../nestoria receipt FINAL (3)_files/image010.png"> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  BRow,
  BCol

} from "bootstrap-vue";
export default {
  props: ["receiptData"],
  components: {
    BRow,
    BCol
  },
  data() {
    return {
      moment,
      array: [],
      cancel:false
    };
  },
}
</script>

<style>
.mainfoo {
  width: 100%;
}

.childfoo {
  /* width:100%; */
  height: 35px;
  color: white;
  display: flex;
  align-items: center;
  font-weight: 500;
  justify-content: space-between;
  font-size: 15px;
  border-radius: 30px 0px 0px 0px;
  background-image: radial-gradient(circle,
      #2aa450,
      #009075,
      #00798a,
      #005f88,
      #074470);
}

.main {
  width: 100%;
  /* margin: 15px 0; */
  display: flex;
  justify-content: center;
}

.header {
  width: 100%;
  display: flex;
  padding: 10px 5px;
}

.receipt {
  width: 100%;
  /* height: 700px; */
  /* margin:  15px auto; */
  /* box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px; */
}

.address {
  font-size: 12px;
  font-weight: 600;
}

.headerlogo {
  width: 30%;
  display: flex;
  flex-direction: column;
}

.receiptBody {
  width: 80%;
  height: 300px;
  border: 1px solid gray;
  margin: 10px auto;
}

.receiptTable {
  border: 2px solid black;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 35% 100%;
  background-image: url("../../../nestoria receipt FINAL (3)_files/screenshot.png");
  border: 1px solid gray;
  margin: 3px 15px;
  justify-content: center;
}

.receiptTable2 {
  border: 2px solid black;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 35% 100%;
  border: 1px solid gray;
  margin: 9px 15px;
  justify-content: center;
}

.tr {
  height: 25px;
}

.td {
  padding-left: 13px;
}

.mainTable {
  border-collapse: collapse;
}

.RulesDiv {
  font-size: 10px;
  font-weight: bolder;
  margin-left: 10px;
  width: 70%;
  color: black;
}

.signBox {
  border-radius: 7px;
  border: 1px solid #6d6357;
  width: 150px;
  height: 70px;
}

.foo {
  justify-content: space-between;
  display: flex;
  width: 800px;
  flex-wrap: wrap;
}

.rule {
  padding: 0;
  margin: 0;
  height: 15px;
}

.mainTable th,
.mainTable td {
  border: 1px solid rgb(92, 92, 92);
}

.payment {
  width: 21%;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 15px;
  background-image: radial-gradient(circle,
      #2aa450,
      #009075,
      #00798a,
      #005f88,
      #074470);
  border-radius: 4px;
  padding: 4px 5px;
  position: relative;
}
.borderImg{
  position: absolute;
  width: 100%;
  z-index: -1;
  top: 50%;  /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
}

p.MsoTitle1,
li.MsoTitle1,
div.MsoTitle1 {
  font-size: 11pt;
  font-family: "Arial", sans-serif;
  font-weight: bold;
}

.headerClass {
  /* padding-left: 44px; */
  padding-bottom: 2px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-image-slice: 1;
}

.innerMain {
  padding-top: 2px;
  width: 800px;
  display: flex;
  justify-content: center;
  height: 14.7cm;
  position: relative;
}

.receipt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tollFree{
  font-size: 15px;
  color: rgb(4, 4, 145);
}
.companyName{
  color:#0a4570;
  font-size:34px;
}
.cancel-receipt{
    font-size: 177px;
    position: absolute;
    z-index: 100000;
    top: 137px;
    right: 38px;
    opacity: 0.5;
    color: red;
    font-weight: bold;
    transform: rotate(-27deg);
}
</style>
